'use client';

import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLORS } from '@/lib/helpers';
import Link from 'next/link';

export const StyledButton = styled(Button)({
  backgroundColor: COLORS.INTER_PRIMARY,
  textTransform: 'none',
  borderRadius: '2px',
  padding: '0.6rem 1rem',
  color: '#FCFCFD',

  '&.black': {
    backgroundColor: '#24292E',
    marginTop: '1rem',
  },

  '&:hover': {
    backgroundColor: '#0055CC',
    color: 'black',
  },
});

export const StyledButtonLink = styled('a')({
  backgroundColor: COLORS.INTER_PRIMARY,
  textTransform: 'none',
  borderRadius: '0',
  padding: '1rem 1rem',
  color: '#FCFCFD',
  textDecoration: 'none',
  width: '100%',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: '500',
  fontSize: '0.875rem',

  '&.black': {
    backgroundColor: '#24292E',
    marginTop: '1rem',
  },

  '&:hover': {
    backgroundColor: '#0055CC',
    color: 'black',
  },
});

export const StyledLink = styled(Link)<{
  href: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}>({
  color: COLORS.INTER_PRIMARY,
  cursor: 'pointer',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const ErrorText = styled(Typography)({
  color: 'red',
  fontWeight: 400,
  padding: '1rem',
  textTransform: 'uppercase',
});

export const SuccessText = styled(Typography)({
  color: 'green',
  fontWeight: 600,
  padding: '1rem',
  textTransform: 'uppercase',
});
